import {IconButton, InputLabel} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

import styled from "styled-components";
import Select from "@mui/material/Select";

interface Props {
    disabled?: boolean;
    filterId: string;
    label: string;
    onChange: (e: any) => void;
    onClear: () => void;
    selectedValue: string;
    children: any;
}

export const Filter = ({disabled=false, filterId, label, onChange, onClear, selectedValue, children}: Props) => (
    <Wrapper>
        <Label id={filterId}>{label}</Label>
        <SelectWrapper
            variant="standard"
            defaultValue = "" 
            disabled={disabled}
            value={selectedValue}
            onChange={onChange}
            inputProps={{
                id: filterId,
                name: filterId
            }}
        >
            {children}
        </SelectWrapper>
        <IconButton onClick={onClear}>
            <ClearIcon/>
        </IconButton>
    </Wrapper>
);

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 80px;
  &:last-child {
    margin: 0;
  }
`;

const Label = styled(InputLabel)`
  margin-right: 20px;
`;

const SelectWrapper = styled(Select)`
  margin-right: 20px;
  min-width: 150px;
`;
